import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import React from "react";
import PurchaseOrderActions from "../../../../reducers/modules/purchasing/purchase-order/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import i18n from "../../../../i18n";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "purchasing/purchase-order";

export default class PurchaseOrderMiddleware {
  static create() {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.update());
      PurchaseOrderMiddleware.showOne(dispatch, params);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.process());
      PurchaseOrderMiddleware.showlist(dispatch, params);
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.resetList());
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.reset());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.view());
      PurchaseOrderMiddleware.showOne(dispatch, params);
    };
  }
  static getPrint(params) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.beforePrint());
      PurchaseOrderMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.submit());
      PurchaseOrderMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeApprove(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(PurchaseOrderActions.approve());
      PurchaseOrderMiddleware.saveApprove(dispatch, post, search);
    };
  }
  static beforeReject(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(PurchaseOrderActions.reject());
      PurchaseOrderMiddleware.saveReject(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.submit());
      PurchaseOrderMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }
  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.delete());
      PurchaseOrderMiddleware.delete(dispatch, params, id);
    };
  }

  static beforeClose(id, params) {
    return (dispatch) => {
      dispatch(PurchaseOrderActions.close());
      PurchaseOrderMiddleware.closing(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      PurchaseOrderMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      PurchaseOrderMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-purchase-order-helper",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseOrderActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseOrderActions.list(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-purchase-order",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseOrderActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseOrderActions.view(response.data.result));
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error);
      });
  }

  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseOrderActions.print(response.data.result));
        }
      })
      .catch((error) => {
        const data=error.response.data;
        switch(data.message){
          case 'Limit':
            dispatch(PurchaseOrderActions.limitPrint());
            const html=<><div>{i18n.t("Enter your message")}</div></>
            MySwal.fire({  
              title:i18n.t("Request to Print"),
              icon:false,
              html:html,
              input: 'textarea',
              inputValue: '',
              showCancelButton: false,  
              showConfirmButton: true,  
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                  if (!value) {
                  return i18n.t("You need to write something!")
                  }
              },
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then((result) => {
                if (result.isConfirmed) {
                    const value= result.value
                    MySwal.fire({
                        title:i18n.t('Proccessing Data'),
                        html:i18n.t('Please Wait ....'),
                        icon:'info',
                    })
                    MySwal.showLoading()
                    PurchaseOrderMiddleware.sendRequest(dispatch,value,params,data.error[1],data.error[2]);
                }
            });   
            return;
          break;
          case 'Reject':
            dispatch(PurchaseOrderActions.limitPrint());
            const htmlreject=<><div className="text-danger">{i18n.t("Your Request Before is Rejected reason :")} <div dangerouslySetInnerHTML={{__html:data.error[0]}}></div><p className="m-0">{data.error[1]}</p>{i18n.t("Please Create a new Request")}</div><div>{i18n.t("Enter your message")}</div></>
            MySwal.fire({  
              title:i18n.t("Request to Print"),
              icon:false,
              html:htmlreject,
              input: 'textarea',
              inputValue: '',
              showCancelButton: false,  
              showConfirmButton: true,  
              allowOutsideClick: false,
              allowEscapeKey: false,
              inputValidator: (value) => {
                  if (!value) {
                  return i18n.t("You need to write something!")
                  }
              },
                allowOutsideClick: false,
                allowEscapeKey: false,
              }).then((result) => {
                if (result.isConfirmed) {
                    const value= result.value
                    MySwal.fire({
                        title:i18n.t('Proccessing Data'),
                        html:i18n.t('Please Wait ....'),
                        icon:'info',
                    })
                    MySwal.showLoading()
                    PurchaseOrderMiddleware.sendRequest(dispatch,value,params,data.error[1],data.error[2]);
                }
            });   
            return;
            break;
          case 'Waiting':
            dispatch(PurchaseOrderActions.saveRequestPrint());
            return;
          case 'Not Found':
              dispatch(PurchaseOrderActions.limitPrint());
              MySwal.fire({
                title:i18n.t('Data Not Found'),
                html:i18n.t('we cant found your request'),
                icon:'error',
            }).then(()=>{
              window.close()
            })
              return;
            break;
            default:
              PurchaseOrderMiddleware.alertHendler(dispatch, error);
              break;
        }
        
      });
  }

  static sendRequest(dispatch,value,params,code,branch){
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "log/print/request",
      responseType: "json",
      data:{
        id:params,
        description:value,
        type:"Reprint Purchase Order",
        code:code,
        branch:branch
      }
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(PurchaseOrderActions.saveRequestPrint());
          PurchaseOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Request To print",
            "success"
          );
        }
      })
      .catch((error) => {
      })
  }
  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseOrderActions.process(),
            PurchaseOrderMiddleware.showlist(dispatch, params)
          );
          PurchaseOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static closing(dispatch, params, id) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url + "/close/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseOrderActions.process(),
            PurchaseOrderMiddleware.showlist(dispatch, params)
          );
          PurchaseOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Closing Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseOrderActions.process(),
            PurchaseOrderMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseOrderActions.success());
          PurchaseOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static saveApprove(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url + "/approve/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseOrderActions.process(),
            PurchaseOrderMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseOrderActions.success());
          PurchaseOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Approve Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error, true);
      });
  }
  static saveReject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url + "/reject/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseOrderActions.process(),
            PurchaseOrderMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseOrderActions.success());
          PurchaseOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reject Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${PurchaseOrderMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            PurchaseOrderActions.process(),
            PurchaseOrderMiddleware.showlist(dispatch, search)
          );
          dispatch(PurchaseOrderActions.success());
          PurchaseOrderMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        PurchaseOrderMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(PurchaseOrderActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(PurchaseOrderActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
